import websiteApi from '@/api/website';

// initial state
const state = {
  news: [],
  newsOnPage: { newsCount: 0, news: [] },
  newsPaging: {
    page: 1,
    pageSize: 20,
  },
  newsItem: {},
};

// getters
const getters = {
  news: (currentState) => currentState.news,
  pagedNews: (currentState) => currentState.newsOnPage,
  newsPaging: (currentState) => currentState.newsPaging,
  newsItem: (currentState) => currentState.newsItem,
};

// actions
const actions = {
  getNews({ dispatch, commit }) {
    dispatch('showLoader');
    websiteApi.getNews().then((response) => {
      commit('setNews', { news: response.data });
      dispatch('hideLoader');
    });
  },
  getPagedNews({ dispatch, commit }, paging) {
    dispatch('showLoader');
    websiteApi.getPagedNews(paging).then((response) => {
      commit('setPagedNews', { news: response.data, paging });
      dispatch('hideLoader');
    });
  },
  createNews({ dispatch }, newsItem) {
    return new Promise((resolve, reject) => {
      websiteApi.createNews(newsItem).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateNews({ dispatch }, newsItem) {
    return new Promise((resolve, reject) => {
      websiteApi.updateNews(newsItem).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  deleteNews({ dispatch }, newsItem) {
    return new Promise((resolve, reject) => {
      websiteApi.deleteNews(newsItem).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
};

// mutations
const mutations = {
  setNews(currentState, { news }) {
    currentState.news = news;
  },
  setPagedNews(currentState, { news, paging }) {
    currentState.newsOnPage = {
      news: news.data,
      newsCount: news.totalDataCount,
    };
    currentState.newsPaging = paging;
  },
  setNews(currentState, { newsItem }) {
    currentState.newsItem = newsItem;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/website.js